const TOKEN_KEY = "assetToken";

const decodeBase64Url = (value: string) => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");

  if (typeof window !== "undefined" && typeof window.atob === "function") {
    return window.atob(padded);
  }
  if (typeof atob === "function") {
    return atob(padded);
  }

  throw new Error("Base64 decoder is not available");
};

const getTokenExpiry = (token: string) => {
  const [, payload] = token.split(".");
  if (!payload) {
    return null;
  }

  try {
    const parsedPayload = JSON.parse(decodeBase64Url(payload));
    return typeof parsedPayload?.exp === "number" ? parsedPayload.exp : null;
  } catch {
    return null;
  }
};

export const checkTokenExpired = () => {
  const token = localStorage.getItem(TOKEN_KEY)?.trim();
  if (!token) {
    return false;
  }

  const tokenExpiry = getTokenExpiry(token);
  if (typeof tokenExpiry === "number") {
    return tokenExpiry * 1000 > Date.now();
  }

  return true;
};

export const setTokenUser = (params: any) => {
  const { token } = params;
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};
